<template>
    <div class="home-news">
        <div class="container">
            <h2 class="relative-section section-title font-balo font-bold">
                <span>{{
                    landingPage.hnews_subtitle
                        ? landingPage.hnews_subtitle
                        : $t("app.dernières news")
                }}</span>
                <b>{{
                    landingPage.hnews_title
                        ? landingPage.hnews_title
                        : $t("app.Notre actualité")
                }}</b>
            </h2>
            <ul class="news-list row">
                <li class="col-md-3" v-for="(item, index) in news" :key="index">
                    <NewsItem :item="item" />
                </li>
            </ul>
            <div class="text-center news-more">
                <router-link to="/blog" class="btn font-balo font-bold">{{
                    landingPage.hnews_button_text
                        ? landingPage.hnews_button_text
                        : $t("app.voir toutes les actualités")
                }}</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import NewsItem from "@/components/NewsItem";
import { mapState } from "vuex";
import { get } from "lodash";
export default {
    name: "LandingNews",
    components: {
        NewsItem
    },
    computed: {
        ...mapState({
            landingPage: state => get(state, "app.landingPage"),
            news: state => get(state, "app.newsHome", [])
        })
    }
};
</script>
